module.exports = __webpack_public_path__ + "static/media/r-md13.10d0ed00.png";